module.exports = __webpack_public_path__ + "img/7.5b2828a4.jpg";